<template>
    <panel-navigation>
        <div v-if="showShareModal" @click.self="showShareModal = false"
            class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center"
            style="background-color: rgba(0,0,0,.2);">
            <div class="w-full sm:w-1/3 lg:w-1/3 bg-white rounded-lg mx-6" style="max-height: 100%;">

                <div class="rg-modal-header">
                    <span>Share Recording URL</span>

                    <a href="javascript: void(0);" class="rg-modal-close-btn" @click="showShareModal = false"><i class="mdi mdi-close"></i></a>
                </div>

                <div class="p-6" style="height: calc(100% - 110px); overflow: auto;">

                    <!--                <div v-if="success" class="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mb-4" role="alert">-->
                    <!--                    {{success}}-->
                    <!--                </div>-->

                    <!--                <div v-if="error" class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4" role="alert">-->
                    <!--                    <div v-html="error"></div>-->
                    <!--                </div>-->

                    <div class="flex flex-wrap">
                        
                        <div class="w-full mb-1 md:mb-0">
                            <p class="mb-1 text-xs mb-2"><strong>
                                Enter Email Address:
                            </strong></p>
                            <input name="name" v-model="recordingEmailAddress"
                                class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded"
                                type="text">

                            <div v-if="shareEmailSent" class="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mt-4" role="alert">
                                Email Sent!
                            </div>
                        </div>

                    </div>
                </div>

                <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                    <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right"
                            :class="{'spinner': sendingRecordingEmail}" @click="sendRecordingEmail();">
                        SEND
                    </button>

                    <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right"
                            @click="showShareModal = false">
                        CLOSE
                    </button>

                    <div class="clearfix"></div>

                </div>


            </div>
        </div>
        
        <div class="float-right pt-3">
            <div class="border-1 border-purple bg-purple text-white text-xs text-bold px-4 py-2 rounded cursor-pointer float-right ml-2" @click="showShareModal = true; shareEmailSent = false"
                    style="margin-top: -10px;"><i class="fa fa-plus mr-2"> </i> SHARE
            </div>
        </div>
        
        <h1 class="text-lg font-semibold mb-3">Call Details</h1>

        <br clear="all" />

        <v-skeleton-loader v-if="loading" type="article, article, article, article, article, article"></v-skeleton-loader>

        <div v-else>
            <div class="flex flex-row flex-wrap mb-2">
                <div class="dashboard-box stats-box w-full pr-1 md:w-1/3 lg:w-1/3">
                    <v-card class="pa-2" tile style="background: #4E7FC5 !important;">
                        <div class="p-2">
                            <div class="dashboard-box-title" style="color: #FFFFFF !important; opacity: 1 !important;">Source Phone Number</div>

                            <div class="call-details-box" style="color: #FFFFFF !important;">{{ call.from }}</div>
                        </div>
                    </v-card>
                </div>
                <div class="dashboard-box stats-box w-full pl-5 pr-2 md:w-1/3 lg:w-1/3" :class="(($vuetify.breakpoint.mobile) ? 'pl-0 pr-0 mt-5' : '')">
                    <v-card class="pa-2" tile style="background: #4E7FC5 !important;">
                        <div class="p-2" style="position: relative;">
                            <div style="position: absolute; right: 0px; z-index: 2; top: 0px;">
                                <v-menu
                                        bottom
                                        right

                                        nudge-bottom='25'
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                                dark
                                                icon
                                                v-bind="attrs"
                                                v-on="on"
                                                class="ml-3"
                                                color="grey darken-1"
                                                :ripple="false"
                                        >
                                            <i class="mdi mdi-dots-vertical"></i>
                                        </v-btn>
                                    </template>

                                    <v-list class="table-menu-actions p-2">
                                        <v-list-item class="hover:bg-gray-200">
                                            <v-list-item-title><a href="javascript: void(0);"><span
                                                class="table-menu-action-icon" style="color: #44468F;" @click="call.tag = 2; setTag(call, 2);">Missed Call</span></a>
                                            </v-list-item-title>
                                        </v-list-item>

                                        <v-list-item class="hover:bg-gray-200">
                                            <v-list-item-title><a href="javascript: void(0);"><span
                                                class="table-menu-action-icon" style="color: #FFB443;" @click="call.tag = 3; setTag(call, 3);">Opportunity</span></a>
                                            </v-list-item-title>
                                        </v-list-item>

                                        <v-list-item class="hover:bg-gray-200">
                                            <v-list-item-title><a href="javascript: void(0);"><span
                                                class="table-menu-action-icon" style="color: #2477F6;" @click="call.tag = 4; setTag(call, 4);">Meeting Scheduled</span></a>
                                            </v-list-item-title>
                                        </v-list-item>

                                        <v-list-item class="hover:bg-gray-200">
                                            <v-list-item-title><a href="javascript: void(0);"><span
                                                class="table-menu-action-icon" style="color: #E53F71;" @click="call.tag = 5; setTag(call, 5);">Became Customer</span></a>
                                            </v-list-item-title>
                                        </v-list-item>

                                        <v-list-item class="hover:bg-gray-200">
                                            <v-list-item-title><a href="javascript: void(0);"><span
                                                class="table-menu-action-icon" style="color: #3EBB80;" @click="call.tag = 1; setTag(call, 1);">Existing Customer</span></a>
                                            </v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </div>
                            <div class="dashboard-box-title" style="color: #FFFFFF !important; opacity: 1 !important;">Tag</div>

                            <div class="call-details-box" style="color: #FFFFFF !important;">
                                
                                <v-chip small v-if="call.tag == 0" class="dark" style="margin-bottom: -4px;">
                                    <span style="font-size: 12px;">Not Set</span>
                                </v-chip>

                                <v-chip small v-if="call.tag == 1" color="#3EBB80" style="margin-bottom: -4px;">
                                    <span style="font-size: 12px; color: #FFFFFF;">Existing Customer</span>

                                    <v-icon class="tags" style="color: #FFFFFF; cursor: pointer; font-size: 14px; margin-left: 4px;" @click="call.tag = 0; removeTag(call);">mdi-close</v-icon>
                                </v-chip>

                                <v-chip small v-if="call.tag == 2" color="#44468F" style="margin-bottom: -4px;">
                                    <span style="font-size: 12px; color: #FFFFFF;">Missed Call</span>

                                    <v-icon class="tags" style="color: #FFFFFF; cursor: pointer; font-size: 14px; margin-left: 4px;" @click="call.tag = 0; removeTag(call);">mdi-close</v-icon>
                                </v-chip>

                                <v-chip small v-if="call.tag == 3" color="#FFB443" style="margin-bottom: -4px;">
                                    <span style="font-size: 12px; color: #FFFFFF;">Opportunity</span>

                                    <v-icon class="tags" style="color: #FFFFFF; cursor: pointer; font-size: 14px; margin-left: 4px;" @click="call.tag = 0; removeTag(call);">mdi-close</v-icon>
                                </v-chip>

                                <v-chip small v-if="call.tag == 4" color="#2477F6" style="margin-bottom: -4px;">
                                    <span style="font-size: 12px; color: #FFFFFF;">Meeting Scheduled</span>

                                    <v-icon class="tags" style="color: #FFFFFF; cursor: pointer; font-size: 14px; margin-left: 4px;" @click="call.tag = 0; removeTag(call);">mdi-close</v-icon>
                                </v-chip>

                                <v-chip small v-if="call.tag == 5" color="#E53F71" style="margin-bottom: -4px;">
                                    <span style="font-size: 12px; color: #FFFFFF;">Became Customer</span>

                                    <v-icon class="tags" style="color: #FFFFFF; cursor: pointer; font-size: 14px; margin-left: 4px;" @click="call.tag = 0; removeTag(call);">mdi-close</v-icon>
                                </v-chip>

                            </div>
                        </div>
                    </v-card>
                </div>
                <div class="dashboard-box stats-box w-full px-5 pr-0 md:w-1/3 lg:w-1/3" :class="(($vuetify.breakpoint.mobile) ? 'pl-0 mt-5' : '')">
                    <v-card class="pa-2" tile style="background: #4E7FC5 !important;">
                        <div class="p-2" style="position: relative;">

                            <div style="position: absolute; right: 0px; z-index: 2; top: 0px;">
                                <v-menu
                                        bottom
                                        left
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                                dark
                                                icon
                                                v-bind="attrs"
                                                v-on="on"
                                                class="ml-3"
                                                color="grey darken-1"
                                                :ripple="false"
                                        >
                                            <i class="mdi mdi-dots-vertical"></i>
                                        </v-btn>
                                    </template>

                                    <v-list class="table-menu-actions">
                                        <v-list-item class="hover:bg-gray-200">
                                            <v-list-item-title><a href="javascript: void(0);" @click="call.qualify_status = 1; setQualifyStatus(call, 1);"><span
                                                class="table-menu-action-icon"><i
                                                class="fa fa-check"></i></span> Set to Qualified</a>
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item class="hover:bg-gray-200">
                                            <v-list-item-title><a href="javascript: void(0);" @click="call.qualify_status = -1; setQualifyStatus(call, -1);"><span
                                                class="table-menu-action-icon"><i
                                                class="mdi mdi-close"></i></span> Set to Unqualified</a>
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item class="hover:bg-gray-200">
                                            <v-list-item-title><a href="javascript: void(0);" @click="call.qualify_status = 2; setQualifyStatus(call, 2);"><span
                                                class="table-menu-action-icon"><i
                                                class="fa fa-ban"></i></span> Set to Spam</a>
                                            </v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </div>

                            <div class="dashboard-box-title" style="color: #FFFFFF !important; opacity: 1 !important;">Status</div>

                            <div class="call-details-box" style="color: #FFFFFF !important;">
                                <v-chip
                                        style="margin-bottom: -4px;"
                                    small
                                    color="gray lighten-5"
                                    text-color="gray lighten-1"
                                
                                    v-if="call.qualify_status == 0"
                            >
                                Not Set
                            </v-chip>

                            <v-chip
                                    style="margin-bottom: -4px;"
                                    small
                                    color="green lighten-5"
                                    text-color="green lighten-1"
                                
                                    v-if="call.qualify_status == 1"
                            >
                                Qualified
                            </v-chip>

                            <v-chip
                                    style="margin-bottom: -4px;"
                                    small
                                    color="red lighten-5"
                                    text-color="red lighten-1"
                                
                                    v-if="call.qualify_status == -1"
                            >
                                Unqualified
                            </v-chip>

                            <v-chip
                                    small
                                    color="red darken-2"
                                    text-color="white"
                                
                                    v-if="call.qualify_status == 2"
                            >
                                Spam
                            </v-chip>

                            </div>
                        </div>
                    </v-card>
                </div>
            </div>

            <div class="flex flex-row flex-wrap mb-4 mt-6">
                <div class="dashboard-box stats-box w-full">
                    <v-card class="pa-4" tile style="background: #4E7FC5 !important;">
                        <b-row>
                            <b-col class="border-right">
                                <div class="p-3">
                                    <div class="dashboard-box-title" style="color: #FFFFFF !important; opacity: 1 !important;">Date and Time</div>

                                    <div class="call-details-box" style="color: #FFFFFF !important;">{{ displayTimestamp(call.created_at) }}</div>
                                </div>
                            </b-col>
                            <b-col class="border-right">
                                <div class="p-3">
                                    <div class="dashboard-box-title" style="color: #FFFFFF !important; opacity: 1 !important;">Call Status</div>

                                    <div class="call-details-box" style="color: #FFFFFF !important;">{{ call.call_status }}</div>
                                </div>
                            </b-col>


                            <b-col class="border-right">
                                <div class="p-3">
                                    <div class="dashboard-box-title" style="color: #FFFFFF !important; opacity: 1 !important;">Duration</div>
                                    <div class="call-details-box" style="color: #FFFFFF !important;">{{ displayDuration(call.duration) }}</div>
                                </div>
                            </b-col>

                            <b-col>
                                <div class="p-3">
                                    <div class="dashboard-box-title" style="color: #FFFFFF !important; opacity: 1 !important;">Dialed Number</div>

                                    <div class="call-details-box" style="color: #FFFFFF !important;">{{ call.to }}</div>
                                </div>
                            </b-col>
                        </b-row>
                    </v-card>
                </div>
            </div>

            <!-- Call Info Start -->
            <div class="flex flex-row flex-wrap w-full mb-4 mt-6">
                <div class="dashboard-box stats-box mb-2 md:w-1/2 lg:w-1/2">
                    <v-card tile>
                        <div class="p-6">
                            <b-row>
                                <b-col md="12">
                                    <div class="call-details-box">Call Info</div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="6">
                                    <div class="sub-heading mt-4" :class="(($vuetify.breakpoint.mobile) ? 'float-none' : 'mb-4')">Start Time</div>
                                </b-col>
                                <b-col md="6">
                                    <div class="sub-heading-vertical mb-4" :class="(($vuetify.breakpoint.mobile) ? 'float-none' : 'mt-4 float-right')">
                                        {{ displayTimestamp(call.created_at) }}
                                    </div>
                                </b-col>
                            </b-row>
                            <hr />
                            <b-row>
                                <b-col md="6">
                                    <div class="sub-heading mt-4" :class="(($vuetify.breakpoint.mobile) ? 'float-none' : 'mb-4')">Source Number</div>
                                </b-col>
                                <b-col md="6">
                                    <div class="sub-heading-vertical mb-4" :class="(($vuetify.breakpoint.mobile) ? 'float-none' : 'mt-4 float-right')">
                                        {{ call.from }}
                                    </div>
                                </b-col>
                            </b-row>
                            <hr />
                            <b-row>
                                <b-col md="6">
                                    <div class="sub-heading mt-4" :class="(($vuetify.breakpoint.mobile) ? 'float-none' : 'mb-4')">Dialed Number</div>
                                </b-col>
                                <b-col md="6">
                                    <div class="sub-heading-vertical mb-4" :class="(($vuetify.breakpoint.mobile) ? 'float-none' : 'mt-4 float-right')">
                                        {{ call.to }}
                                    </div>
                                </b-col>
                            </b-row>
                            <hr />
                            <b-row>
                                <b-col md="6">
                                    <div class="sub-heading mt-4" :class="(($vuetify.breakpoint.mobile) ? 'float-none' : 'mb-4')">Call Status</div>
                                </b-col>
                                <b-col md="6">
                                    <div class="sub-heading-vertical mb-4" :class="(($vuetify.breakpoint.mobile) ? 'float-none' : 'mt-4 float-right')">
                                        {{ call.call_status }}
                                    </div>
                                </b-col>
                            </b-row>
                            <hr />
                            <b-row>
                                <b-col md="6">
                                    <div class="sub-heading mt-4" :class="(($vuetify.breakpoint.mobile) ? 'float-none' : 'mb-4')">Attempts</div>
                                </b-col>
                                <b-col md="6">
                                    <div class="sub-heading-vertical mb-4" :class="(($vuetify.breakpoint.mobile) ? 'float-none' : 'mt-4 float-right')">1</div>
                                </b-col>
                            </b-row>
                            <hr />
                            <b-row>
                                <b-col md="6">
                                    <div class="sub-heading mt-4" :class="(($vuetify.breakpoint.mobile) ? 'float-none' : 'mb-4')">Duration</div>
                                </b-col>
                                <b-col md="6">
                                    <div class="sub-heading-vertical mb-4" :class="(($vuetify.breakpoint.mobile) ? 'float-none' : 'mt-4 float-right')">
                                        {{ displayDuration(call.duration) }}
                                    </div>
                                </b-col>
                            </b-row>
                            <hr />
                            <b-row>
                                <b-col md="6">
                                    <div class="sub-heading mt-4" :class="(($vuetify.breakpoint.mobile) ? 'float-none' : 'mb-4')">Recording URL</div>
                                </b-col>
                                <b-col md="6">
                                    <div class="sub-heading-vertical mb-4" :class="(($vuetify.breakpoint.mobile) ? 'float-none' : 'mt-4 float-right')">
                                        <div v-if="call.recording_url">
                                            <i class="audio-element-icon fa fa-play" :id="'audio-element-icon-' + call.id + '2'" style="cursor: pointer;" @click="playAudio(call, 2);"></i>

                                            <div class="audio-element-wrapper" :id="'audio-element-wrapper-' + call.id + '2'" style="display: none !important;">
                                                <i class="mdi mdi-close-circle" style="position: absolute; right: 10px; top: 20px; font-size: 20px; z-index: 99; cursor: pointer;" @click="playAudio(call, 2)"></i>
                                                <audio class="audio-element" :id="'audio-element-' + call.id + '2'" controls="play, pause, volume" style="height: 38px;">
                                                    <source :src="call.recording_url" type="audio/mpeg">
                                                </audio>
                                            </div>
                                        </div>
                                        <div v-else>
                                            -
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                            <hr />
                            <b-row>
                                <b-col md="6">
                                    <div class="sub-heading mt-4" :class="(($vuetify.breakpoint.mobile) ? 'float-none' : 'mb-4')">Tag</div>
                                </b-col>
                                <b-col md="6">
                                    <div class="sub-heading-vertical mb-4" :class="(($vuetify.breakpoint.mobile) ? 'float-none' : 'mt-4 float-right')">
                                        <v-chip small v-if="call.tag == 0" class="dark" style="margin-bottom: -4px;">
                                            <span style="font-size: 12px;">Not Set</span>
                                        </v-chip>

                                        <v-chip small v-if="call.tag == 1" color="#3EBB80" style="margin-bottom: -4px;">
                                            <span style="font-size: 12px; color: #FFFFFF;">Existing Customer</span>

                                            <!-- <v-icon class="tags" style="color: #FFFFFF; cursor: pointer; font-size: 14px; margin-left: 4px;" @click="call.tag = 0; removeTag(call);">mdi-close</v-icon> -->
                                        </v-chip>

                                        <v-chip small v-if="call.tag == 2" color="#44468F" style="margin-bottom: -4px;">
                                            <span style="font-size: 12px; color: #FFFFFF;">Missed Call</span>

                                            <!-- <v-icon class="tags" style="color: #FFFFFF; cursor: pointer; font-size: 14px; margin-left: 4px;" @click="call.tag = 0; removeTag(call);">mdi-close</v-icon> -->
                                        </v-chip>

                                        <v-chip small v-if="call.tag == 3" color="#FFB443" style="margin-bottom: -4px;">
                                            <span style="font-size: 12px; color: #FFFFFF;">Opportunity</span>

                                            <!-- <v-icon class="tags" style="color: #FFFFFF; cursor: pointer; font-size: 14px; margin-left: 4px;" @click="call.tag = 0; removeTag(call);">mdi-close</v-icon> -->
                                        </v-chip>

                                        <v-chip small v-if="call.tag == 4" color="#2477F6" style="margin-bottom: -4px;">
                                            <span style="font-size: 12px; color: #FFFFFF;">Meeting Scheduled</span>

                                            <!-- <v-icon class="tags" style="color: #FFFFFF; cursor: pointer; font-size: 14px; margin-left: 4px;" @click="call.tag = 0; removeTag(call);">mdi-close</v-icon> -->
                                        </v-chip>

                                        <v-chip small v-if="call.tag == 5" color="#E53F71" style="margin-bottom: -4px;">
                                            <span style="font-size: 12px; color: #FFFFFF;">Became Customer</span>

                                            <!-- <v-icon class="tags" style="color: #FFFFFF; cursor: pointer; font-size: 14px; margin-left: 4px;" @click="call.tag = 0; removeTag(call);">mdi-close</v-icon> -->
                                        </v-chip>
                                    </div>
                                </b-col>
                            </b-row>
                            <hr />
                            <b-row>
                                <b-col md="6">
                                    <div class="sub-heading mt-4" :class="(($vuetify.breakpoint.mobile) ? 'float-none' : 'mb-4')">Status</div>
                                </b-col>
                                <b-col md="6">
                                    <div
                                            class="sub-heading-vertical mt-4 mb-4 float-right"
                                    >
                                    <v-chip
                                        style="margin-bottom: -4px;"
                                            small
                                            color="gray lighten-5"
                                            text-color="gray lighten-1"
                                        
                                            v-if="call.qualify_status == 0"
                                    >
                                        Not Set
                                    </v-chip>

                                    <v-chip
                                            style="margin-bottom: -4px;"
                                            small
                                            color="green lighten-5"
                                            text-color="green lighten-1"
                                        
                                            v-if="call.qualify_status == 1"
                                    >
                                        Qualified
                                    </v-chip>

                                    <v-chip
                                            style="margin-bottom: -4px;"
                                            small
                                            color="red lighten-5"
                                            text-color="red lighten-1"
                                        
                                            v-if="call.qualify_status == -1"
                                    >
                                        Unqualified
                                    </v-chip>

                                    <v-chip
                                            small
                                            color="red darken-2"
                                            text-color="white"
                                        
                                            v-if="call.qualify_status == 2"
                                    >
                                        Spam
                                    </v-chip>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </v-card>

                    <v-card tile class="mt-6">
                        <div class="p-6">
                            <b-row>
                                <b-col md="12">
                                    <div class="call-details-box">Logs</div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="12">
                                    <div class="sub-heading p-2" style="background-color: #f7f8f8">
                                        Call Initiated by caller +19044181470 dialing +19042040590
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="12">
                                    <div class="sub-heading p-2">Playing greeting</div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="12">
                                    <div class="sub-heading p-2" style="background-color: #f7f8f8">
                                        Playing prompt
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="12">
                                    <div class="sub-heading p-2">
                                        Prompt key pressed
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="12">
                                    <div class="sub-heading p-2" style="background-color: #f7f8f8">
                                        Calling destination numbers
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="12">
                                    <div class="sub-heading p-2" style="background-color: #f7f8f8">
                                        Destination number answered
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="12">
                                    <div class="sub-heading p-2">Call recording ready</div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="12">
                                    <div class="sub-heading p-2" style="background-color: #f7f8f8">
                                        Call has terminated with total duration: 51
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </v-card>
                </div>
                <div class="dashboard-box stats-box mb-2 w-full px-2 md:w-1/2 lg:w-1/2 pl-5" :class="(($vuetify.breakpoint.mobile) ? 'pl-0 pr-0' : '')">
                    <v-card tile>
                        <div class="p-8">

                            <div v-if="call.recording_url">
                                
                            
                            <b-row>
                                <b-col class="call-details-box">Inbound Recorded Call</b-col>


                                <b-col cols="12" md="auto"
                                ><Button class="music-button" :class="(($vuetify.breakpoint.mobile) ? '' : '-mt-4')" @click="showShareModal = true; shareEmailSent = false">
                    <span class="flex text-sm">
                        <mail-icon size="1x" class="custom-class mr-2"></mail-icon>
                        E-Mail
                    </span>
                                </Button></b-col
                                >
                                <b-col cols="12" md="auto"
                                ><Button class="music-button" :class="(($vuetify.breakpoint.mobile) ? '' : '-mt-4')" @click="downloadMp3()">
                    <span class="flex text-sm"
                    ><download-icon
                            size="1x"
                            class="custom-class mr-2"
                    ></download-icon
                    >Download MP3</span
                    >
                                </Button></b-col
                                >
                            </b-row>

                            <div style="clear: both; padding-top: 50px;">
                                <audio class="audio-element" :id="'audio-element-' + call.id" controls="play, pause, volume" style="width: 100%;">
                                    <source :src="call.recording_url" type="audio/mpeg">
                                </audio>
                            </div>

                            </div>
                            <div v-else>
                                No recording found.
                            </div>
                        </div>
                    </v-card>

                    <v-card tile class="mt-6">
                        <div class="p-6">
                            <b-row class="">
                                <b-col md="12">
                                    <div class="call-details-box">Transcription <!-- <span style="font-weight: normal;">(with sentiment analysis)</span> --></div>
                                    <!-- <div class="mt-4">
                                        <span class="mr-3 primary-pill"> Service Provider </span>
                                        <span class="mr-3 danger-pill"> Service Technician </span>
                                        <span class="mr-3 warning-pill"> Appointment </span>
                                    </div>
                                    <div class="mt-6">
                                        <b>Transcription</b>
                                        <span class="dashboard-box-title">
                        (With sentiment analysis)
                    </span>
                                    </div>
                                    <div class="mt-4 sub-heading">
                                        This is your local internet service provider.
                                    </div> -->

                                    <div v-if="!call.transcription" class="text-sm">
                                        <br />
                                        No transcription available.
                                    </div>
                                    <div v-else>
                                        <div v-if="!call.transcription" class="text-sm">
                                            <br />
                                            <i class="fa fa-spin fa-spinner"></i>
                                            
                                            &nbsp; Please wait. We are transcribing your call.. Check back later.
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                            <div v-if="call.transcription" style="max-height: 335px; overflow-y: auto; padding-bottom: 20px;">
                                <div v-if="call.transcription.length == 0" class="text-sm">
                                    <br />
                                    No transcription available.
                                </div>
                                <b-row>
                                    <b-col md="12">
                                        <b-list-group>
                                            <b-list-group-item

                                                v-for="(item, index) in call.transcription" :key="index"
                                        
                                                    class="d-flex align-items-center mb-4 pb-4"
                                                    style="border: none; border-bottom: solid 1px #ededed;"
                                            >
                                                <b-avatar v-if="item.speaker == 'A'"
                                                        text="S1"
                                                        class="mr-3 call-info-avatar"
                                                ></b-avatar>
                                                <b-avatar v-if="item.speaker == 'B'"
                                                        text="S2"
                                                        class="mr-3 call-info-avatar"
                                                ></b-avatar>
                                                <div>
                                                    <span v-if="item.speaker == 'A'" class="mr-auto primary-color text-bold">Speaker 1</span>
                                                    <span v-else class="mr-auto warning-color text-bold">Speaker 2</span>

                                                    <span class="mr-auto"> . {{ displaySpeakerTimestamp(item.start) }} . </span>
                                                    <!-- <span v-if="item.sentiment == 'Neutral'" class="mr-auto warning-color text-bold">Neutral</span>
                                                    <span v-if="item.sentiment == 'Positive'" class="mr-auto success-color text-bold">Positive</span>
                                                    <span v-if="item.sentiment == 'Negative'" class="mr-auto danger-color text-bold">Negative</span> -->
                                                    <div class="text-sm">{{ item.text }}</div>
                                                </div>
                                            </b-list-group-item>
                                        </b-list-group>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                    </v-card>

                    <v-card tile class="mt-6">
                        <div class="p-6">
                            <b-row>
                                <b-col md="12">
                                    <div class="call-details-box">Destination Information</div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="6">
                                    <div class="sub-heading mt-4" :class="(($vuetify.breakpoint.mobile) ? 'float-none' : 'mb-4')">Destination Title</div>
                                </b-col>
                                <b-col md="6">
                                    <div class="sub-heading-vertical mb-4" :class="(($vuetify.breakpoint.mobile) ? 'float-none' : 'mt-4 float-right')">
                                        Business Call Flow
                                    </div>
                                </b-col>
                            </b-row>
                            <hr />
                            <b-row>
                                <b-col md="6">
                                    <div class="sub-heading mt-4" :class="(($vuetify.breakpoint.mobile) ? 'float-none' : 'mb-4')">Destination Number</div>
                                </b-col>
                                <b-col md="6">
                                    <div class="sub-heading-vertical mb-4" :class="(($vuetify.breakpoint.mobile) ? 'float-none' : 'mt-4 float-right')">
                                        +19046197394
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </v-card>

                    <v-card tile class="mt-6">
                        <div class="p-10">
                            <b-row>
                                <b-col md="12">
                                    <div class="details-box">Call History</div>
                                </b-col>
                            </b-row>
                            <b-row offset-md="3" class="justify-content-md-center">
                                <b-col md="3">
                                    <div class="dashboard-box-title">
                                        <div>
                                            <Button
                                                    style="
                            background-color: #dee2e6;
                            padding: 15px;
                            border-radius: 5px;
                            margin-left: 60px;
                        "
                                                    class="mb-4"
                                            >
                                                <phone-call-icon
                                                        size="5x"
                                                        class="custom-class"
                                                ></phone-call-icon>
                                            </Button>
                                        </div>
                                        No History For This Caller
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </v-card>
                </div>
            </div>
            <!-- Call Info End -->
            <!-- Logs Start -->
            <!-- <div class="flex flex-row flex-wrap mb-0 mt-1"> -->
                <!-- <div class="dashboard-box stats-box w-full px-2 mb-4 md:w-1/2 lg:w-1/2 pl-5"> -->
                    <!-- <v-card tile>
                        <div class="p-10">
                            <b-row>
                                <b-col md="12">
                                    <div class="call-details-box">Call Geo Info</div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="6">
                                    <div class="sub-heading mt-4" :class="(($vuetify.breakpoint.mobile) ? 'float-none' : 'mb-4')">City</div>
                                </b-col>
                                <b-col md="6">
                                    <div class="sub-heading mt-4 mb-4 float-right">
                                        Jacksonville
                                    </div>
                                </b-col>
                            </b-row>
                            <hr />
                            <b-row>
                                <b-col md="6">
                                    <div class="sub-heading mt-4" :class="(($vuetify.breakpoint.mobile) ? 'float-none' : 'mb-4')">Region/State/Province</div>
                                </b-col>
                                <b-col md="6">
                                    <div class="sub-heading mt-4 mb-4 float-right">FL</div>
                                </b-col>
                            </b-row>
                            <hr />
                            <b-row>
                                <b-col md="6">
                                    <div class="sub-heading mt-4" :class="(($vuetify.breakpoint.mobile) ? 'float-none' : 'mb-4')">Zip/postal Code</div>
                                </b-col>
                                <b-col md="6">
                                    <div class="sub-heading mt-4 mb-4 float-right">32204</div>
                                </b-col>
                            </b-row>
                            <hr />
                            <b-row>
                                <b-col md="6">
                                    <div class="sub-heading mt-4" :class="(($vuetify.breakpoint.mobile) ? 'float-none' : 'mb-4')">Country</div>
                                </b-col>
                                <b-col md="6">
                                    <div class="sub-heading mt-4 mb-4 float-right">US</div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="12">
                                    <div class="sub-heading">
                                        <b-img :src="mapImage" alt="Map" />
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </v-card> -->

                    <!-- <v-card tile class="mt-6">
                        <div class="p-10">
                            <b-row>
                                <b-col md="12">
                                    <div class="call-details-box">Actions</div>
                                    <div class="mt-6">
                                        <span class="mr-3 primary-pill"> Action Item </span>
                                    </div>
                                    <div class="mt-6 sub-heading">
                                        This is your local internet service provider.
                                    </div>
                                </b-col>
                                <b-col md="12">
                                    <hr />
                                    <div class="mt-6">
                                        <span class="mr-3 primary-pill"> Action Item </span>
                                    </div>
                                    <div class="mt-6 sub-heading">
                                        I will finish my work by 5 PM so you could send a technician
                                        after.
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </v-card> -->

                    
                <!-- </div> -->
            <!-- </div> -->
            <!-- Logs End -->

            <!-- Call History Start -->
            <!-- <div class="flex flex-row flex-wrap mb-1 mt-1">
                
            </div> -->
            <!-- Call History End -->

            <!-- Analytics Start -->
            <!-- <div class="flex flex-row flex-wrap mb-2 mt-1">
                <div class="dashboard-box stats-box w-full mb-4">
                    <v-card tile>
                        <div class="p-10">
                            <b-row class="mb-4">
                                <b-col md="12">
                                    <div class="details-box">Analytics</div>
                                </b-col>
                            </b-row>
                            <hr />
                            <b-row class="justify-content-md-center mt-4">
                                <b-col md="4">
                                    <div class="dashboard-box-title">
                                        Talk Vs Silence
                                        <div id="chart" style="margin-left: -40px" class="mb-4 mt-4">
                                            <apexchart
                                                    type="donut"
                                                    width="380"
                                                    :options="chartOptions"
                                                    :series="series"
                                            ></apexchart>
                                        </div>
                                        Talk Time, Silence
                                    </div>
                                </b-col>
                                <b-col md="4">
                                    <div class="dashboard-box-title">
                                        Speech Speed
                                        <div>
                                        </div>
                                        236 words/min
                                    </div>
                                </b-col>
                                <b-col md="4">
                                    <div class="dashboard-box-title">
                                        Longest Monologue
                                        <div></div>
                                        <span style="text-align: center"> 3 Sec</span>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </v-card>
                </div>
            </div> -->
        </div>

        <!-- Analytics End -->
    </panel-navigation>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import PanelNavigation from "@/components/PanelNavigation.vue";
import moment from 'moment'
// import VueSpeedometer from "vue-speedometer";

// import Map from "@/assets/map.png";
import VueApexCharts from "vue-apexcharts";

export default {
    metaInfo() {
        return {
            title: "Call Details | " + this.$appName,
        };
    },
    components: {
        apexchart: VueApexCharts,
        PanelNavigation
    },
    // template: `<vue-speedometer />`,
    data() {
        return {
            toggle: false,
            series: [44, 55],

            loading: false,

            showShareModal: false,
            recordingEmailAddress: "",
            shareEmailSent: false,
            sendingRecordingEmail: false,

            chartOptions: {
                colors: ["#dadae9", "#44468F"],
                chart: {
                    width: 380,
                    type: "donut",
                },
                plotOptions: {
                    pie: {
                        startAngle: -90,
                        endAngle: 270,
                    },
                },
                dataLabels: {
                    enabled: false,
                    name: {
                        show: false, // Set to false to hide the series name
                    },
                },
                title: {
                    // text: "Gradient Donut with custom Start-angle",
                },
                responsive: [
                    {
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200,
                            },
                            legend: {
                                position: "bottom",
                            },
                        },
                    },
                ],
            },
            mapImage: Map,
            userSegmentation: false,
            saving: false,
            error: null,

            changing: false,
            error_password: null,
            password_changed: false,

            phone_number_changed: false,
            show_phone_verification_modal: false,

            call: null
        };
    },
    methods: {
        downloadMp3() {
            window.open(this.call.recording_url);
        },
        displayTimestamp(date) {
            let timezone = "America/New_York";

            return moment.utc(date).tz(timezone).format('ddd M/D YYYY h:mm:ss A');
        },

        displaySpeakerTimestamp(milliseconds) {
            //Get hours from milliseconds
  var hours = milliseconds / (1000*60*60);
  var absoluteHours = Math.floor(hours);
  var h = absoluteHours > 9 ? absoluteHours : '0' + absoluteHours;

  //Get remainder from hours and convert to minutes
  var minutes = (hours - absoluteHours) * 60;
  var absoluteMinutes = Math.floor(minutes);
  var m = absoluteMinutes > 9 ? absoluteMinutes : '0' +  absoluteMinutes;

  //Get remainder from minutes and convert to seconds
  var seconds = (minutes - absoluteMinutes) * 60;
  var absoluteSeconds = Math.floor(seconds);
  var s = absoluteSeconds > 9 ? absoluteSeconds : '0' + absoluteSeconds;


  return h + ':' + m + ':' + s;
        },

        playAudio(item, nr = 1) {
            if (item.type == 'callrail') {
                window.open(item.recording_url);
                return;
            }
            
            if (document.getElementById('audio-element-wrapper-' + item.id + nr).style.display == 'none') {
                let elements = document.getElementsByClassName('audio-element-wrapper');

                for (var i in elements) {
                    try {
                        elements[i].style.display = 'none';
                    }
                    catch (e) {}
                }

                let elements2 = document.getElementsByClassName('audio-element');

                for (var i in elements) {
                    try {
                        elements2[i].pause();
                        elements2[i].currentTime = 0;
                    }
                    catch (e) {}
                }

                let elements3 = document.getElementsByClassName('audio-element-icon');

                for (var i in elements) {
                    try {
                        elements3[i].style.display = 'block';
                    }
                    catch (e) {}
                }

                document.getElementById('audio-element-wrapper-' + item.id + nr).style.display = 'block';
                document.getElementById('audio-element-' + item.id + nr).play();

                document.getElementById('audio-element-icon-' + item.id + nr).style.display = 'none';

                
            }
            else {
                document.getElementById('audio-element-wrapper-' + item.id + nr).style.display = 'none';
                document.getElementById('audio-element-' + item.id + nr).pause();
                document.getElementById('audio-element-' + item.id + nr).currentTime = 0;

                document.getElementById('audio-element-icon-' + item.id + nr).style.display = 'block';
            }
        },

        displayDuration(time) {
            var sec_num = time // don't forget the second param
            var hours   = Math.floor(sec_num / 3600);
            var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
            var seconds = sec_num - (hours * 3600) - (minutes * 60);

            if (hours   < 10) {hours   = "0"+hours;}
            if (minutes < 10) {minutes = "0"+minutes;}
            if (seconds < 10) {seconds = "0"+seconds;}
            return hours+':'+minutes+':'+seconds;
        },

        async getCallDetails(silent = false) {
            let self = this;

            if (!silent)
                this.loading = true;

            let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-call-details`, {
                call_sid: self.$route.params.call_sid
            }, {
                headers: {
                    'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                }
            })

            this.call = response.data.call;
            this.loading = false;

            if (this.call.recording_url && !this.call.transcription) {
                setTimeout(function() {
                    self.getCallDetails(true);
                }, 5000);
            }
        },

        async sendRecordingEmail(silent = false) {
            if(!this.recordingEmailAddress)
                return;

            this.shareEmailSent = false;
            this.sendingRecordingEmail = true;

            let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/send-recording-email`, {
                call_sid: this.call.call_sid,
                recordingEmailAddress: this.recordingEmailAddress
            }, {
                headers: {
                    'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                }
            })

            this.sendingRecordingEmail = false;
            // this.showShareModal = false;
            this.shareEmailSent = true;
            this.recordingEmailAddress = "";
        },

        async setTag(item, tag) {
            let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/set-tag`, {
                call_id: item.id,
                tag: tag
            }, {
                headers: {
                    'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                }
            })

            this.getCalls(true);
        },

        async removeTag(item) {
            let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/remove-tag`, {
                call_id: item.id
            }, {
                headers: {
                    'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                }
            })

            this.getCalls(true);
        },

        async setQualifyStatus(item, qualify_status) {
            let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/set-qualify-status`, {
                call_id: call.id,
                qualify_status: qualify_status
            }, {
                headers: {
                    'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                }
            })
        },
    },
    computed: {
        ...mapState({
            me: (state) => state.me.me,
            profile: (state) => state.me.profile,
        }),
    },
    created() {
        this.$store.dispatch("me/fetch");
        this.getCallDetails();
    },
};
</script>

<style scoped>
.setting-header {
    background-color: #fbfbfb;
}
.setting-body {
    background-color: #fdfdfd;
}
.gravatar-pic {
    border-radius: 50%;
    width: 100px;
    display: initial;
    margin-bottom: 6px;
}

.call-details-box {
    font-weight: bold;
    font-size: 14px;
    padding-top: 10px;
}
</style>
